import { useEffect } from "react";

import { useFeatureIslandCategoryContext } from "@/components/features/_layouts/island/main-with-category/context";

/**
 * カテゴリサイドメニューの青丸表示を制御するhook
 * 値が入っている場合に青丸を表示する
 */
export const useEditedQuestionIndicator = (questionTitle: string, hasValue: boolean) => {
	const addEditedQuestionTitle = useFeatureIslandCategoryContext((state) => state.addEditedQuestionTitle);
	const removeEditedQuestionTitle = useFeatureIslandCategoryContext((state) => state.removeEditedQuestionTitle);

	useEffect(() => {
		if (hasValue) {
			addEditedQuestionTitle(questionTitle);
		} else {
			removeEditedQuestionTitle(questionTitle);
		}
	}, [hasValue, questionTitle, addEditedQuestionTitle, removeEditedQuestionTitle]);
};
